module.exports = __webpack_public_path__ + "img/centre-dingenierie.7e7aece9.jpeg";